import HandleThemeChange from "./HandleThemeChange";

export default HandleThemeChange;
